import { first } from "lodash";
import { matchPath, useNavigate } from "react-router-dom";

//Leaving the parameter empty in any path will result in the path 'pattern' being used - e.g. ":itemID".
export type Path =
  | "/"
  | "/landing"
  | "/auth"
  | "/reset-password"
  | "/form-examples"
  | "/project"
  | "/template"
  | "/projects"
  | "/templates"
  | "/templates-admin"
  | "/collections-admin"
  | "/collection-admin"
  | "/my-orders"
  | "/my-account"
  | "/terms"
  | "/privacy-policy"
  | "/cookie-policy";

export const usePaths = () => {
  const navigate = useNavigate();

  const home = "/";
  const landing = "/landing";
  const auth = "/auth";
  const resetPassword = "/reset-password";
  const formExamples = "/form-examples";
  const mapEditor = "/project";
  const templateEditor = "/template";
  const projectList = "/projects";
  const templateList = "/templates";
  const templateListAdmin = "/templates-admin";
  const collectionsAdmin = "/collections-admin";
  const collectionEditAdmin = "/collection-admin";
  // For rendering the poster.
  const processOrder = "/process-order";
  const checkoutReview = "/checkout-review";
  const checkout = "/checkout";
  const checkoutConfirmation = "/checkout-confirmation";

  const collectionList = "/collection-list";
  const firstCollectionList = "/collection-list/A";
  const collection = "/collection";
  const myOrders = "/my-orders";
  const myAccount = "/my-account";
  const terms = "/terms";
  const cookiePolicy = "/cookie-policy";
  const privacyPolicy = "/privacy-policy";

  const navigateTo = (path: string) => {
    if (!pathMatches(window.location.pathname, path)) {
      navigate(path);
    }
  };

  const navigateToIgnoringPathMatch = (path: string) => {
    navigate(path);
  };

  const pathMatches = (path1: string, path2: string): boolean => {
    const path1WithoutTrailingPath = path1.replace(/\/$/, "");
    const path2WithoutTrailingPath = path2.replace(/\/$/, "");
    return path1WithoutTrailingPath === path2WithoutTrailingPath;
  };

  const isOnPage = (path: string): boolean => {
    return matchPath({ path, end: false }, window.location.pathname) !== null;
  };

  return {
    navigateTo,
    navigateToIgnoringPathMatch,
    pathMatches,
    isOnPage,
    home,
    landing,
    auth,
    resetPassword,
    formExamples,
    mapEditor,
    templateEditor,
    projectList,
    templateList,
    templateListAdmin,
    collectionsAdmin,
    collectionEditAdmin,
    processOrder,
    checkoutReview,
    checkout,
    checkoutConfirmation,
    collectionList,
    firstCollectionList,
    collection,
    myOrders,
    myAccount,
    terms,
    cookiePolicy,
    privacyPolicy,
  } as const;
};
